import React from 'react';
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

// The confirm step every irreversible action shares (lock code, finish a tie-break, submit a lesson,
// delete, share for research): it repeats what will happen, and keeps the dialog open with the error
// if the call fails.
const ConfirmDialog = ({
    open,
    title,
    children,
    confirmLabel,
    cancelLabel = 'Cancel',
    onConfirm,
    onClose,
    busy = false,
    error,
    destructive = false,
    confirmDisabled = false,
}) => {
    const titleId = React.useId();
    return (
        <Dialog open={open} onClose={busy ? undefined : onClose} aria-labelledby={titleId} maxWidth="xs" fullWidth>
            <DialogTitle id={titleId} sx={{ typography: 'h5', pb: 1 }}>{title}</DialogTitle>
            <DialogContent sx={{ color: 'text.secondary' }}>
                {children}
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                <Button onClick={onClose} disabled={busy}>{cancelLabel}</Button>
                <Button
                    variant="contained"
                    color={destructive ? 'error' : 'primary'}
                    onClick={onConfirm}
                    disabled={busy || confirmDisabled}
                    startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
                    autoFocus
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
